import yoga from '../Images/yoga.jpg'
import gym24 from '../Images/gym24.jpg';
import allequip from '../Images/allequipjpg.jpg';
import trainers from '../Images/trainers.jpg';
const NewData={
    img1: yoga,
    title1:"Yoga",
    link1:"/yoga",
    img2: gym24,
    title2:"24x7 gym",
    link2:"/gym24",
    img3: allequip,
    title3:"all equipments",
    link3:"/allequip",
    img4: trainers,
    title4:"trainers",
    link4:"/trainers",
    
}
  

export default NewData;